
import React from 'react';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/c5aec43ff44ad69b277ad88e66bd5220.jpeg')`
      }}
    >
      {/* Dark Overlay for better text visibility */}
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="flex items-center justify-center min-h-screen">
          {/* Centered Content */}
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              地方を
              <br />
              <span style={{ color: '#007AFF' }}>マーケティングで</span>
              <br />
              強化する
            </h1>
            
            <p className="text-xl md:text-2xl leading-relaxed mb-8 text-white/90 max-w-3xl mx-auto">
              マーケティングで、あなたのビジネスを次のレベルへ。
              <br />
              地域密着型のアプローチで確実な成果をお届けします。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="#contact"
                className="inline-flex items-center justify-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-[10px] hover:bg-blue-700 hover:scale-105 hover:shadow-lg transform transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line text-xl mr-3"></i>
                無料相談を申し込む
              </a>
              <a 
                href="#services"
                className="inline-flex items-center justify-center px-8 py-4 bg-white/20 backdrop-blur-sm text-white font-semibold rounded-[10px] border border-white/30 hover:bg-white/30 hover:scale-105 hover:shadow-lg transform transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-down-line text-xl mr-3"></i>
                サービス詳細
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
